<template>
  <transition enter-active-class="animate__animated animate__fadeInLeft">
    <div class="banner-wrap" v-if="animate">
      <el-carousel v-bind="carouselConfig" trigger="click" :interval="10000">
        <el-carousel-item
          v-for="slide in bannerSlides"
          :key="slide.image"
        >
          <el-image
            class="banner-image"
            :src="'/' + slide.image"
            :alt="slide.title || ''"
            fit="contain"
          ></el-image>
          <div v-if="slide.title" class="banner-copy">
            <h1>{{ slide.title }}</h1>
            <p>{{ slide.subtitle }}</p>
            <button
              type="button"
              class="banner-action"
              @click.stop="handleBannerAction(slide)"
            >
              {{ slide.action }}
            </button>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      animate: false,
    };
  },

  computed: {
    bannerSlides() {
      if (this.isCnLocale()) {
        return [
          {
            image: "banner-ddr5-pmic.png",
            title: "服务器 DDR5 PMIC",
            subtitle: "适配 RDIMM/MRDIMM 模组的高性能电源管理芯片",
            action: "详情",
            pid: "SX6000",
          },
          { image: "banner3-cn.png" },
          { image: "banner2-cn.png" },
          { image: "banner1-cn.png" },
        ];
      }
      return [
        {
          image: "banner-ddr5-pmic.png",
          title: "DDR5 PMIC for Servers",
          subtitle: "High performance PMICs for RDIMM and MRDIMM modules",
          action: "Detail",
          pid: "SX6000",
        },
        { image: "banner3.png" },
        { image: "banner2.png" },
        { image: "banner1.png" },
      ];
    },

    carouselConfig() {
      if (this.isMobile) {
        return {
          width: "100vw",
          height: "400px",
        };
      }
      return {
        width: "100vw",
        height: "calc(100vh - 70px)",
      };
    },
  },

  mounted() {
    setTimeout(() => {
      this.animate = true;
    });
  },

  methods: {
    handleBannerAction(slide) {
      if (!slide.pid) return;
      this.$store.dispatch("CHANGE_PRODUCT", ["DDR5 PMIC", slide.pid]);
      this.$router.push({
        path: this.isCnLocale() ? "/products" : "/products/en",
        query: { pid: slide.pid },
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.banner-wrap {
  overflow: hidden;
  position: relative;
  // height: 100vh;
  width: 100%;
  box-sizing: border-box;
  background-color: #000;
  margin-top: 70px;

  .banner-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .banner-copy {
    position: absolute;
    z-index: 2;
    left: clamp(28px, 9vw, 150px);
    top: 50%;
    width: min(520px, calc(100% - 56px));
    color: #fff;
    text-align: left;
    transform: translateY(-50%);
    text-shadow: 0 2px 16px rgba(0, 0, 0, 0.65);

    h1 {
      margin: 0 0 18px;
      font-size: clamp(30px, 4vw, 58px);
      line-height: 1.12;
    }

    p {
      margin: 0 0 30px;
      font-size: clamp(16px, 1.7vw, 24px);
      line-height: 1.5;
    }
  }

  .banner-action {
    padding: 12px 28px;
    border: 1px solid #63c6f2;
    border-radius: 4px;
    color: #fff;
    background: #168fc5;
    font: inherit;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
    transition: background-color 0.2s ease, transform 0.2s ease;

    &:hover {
      background: #33a1d0;
      transform: translateY(-1px);
    }

    &:focus-visible {
      outline: 3px solid #fff;
      outline-offset: 3px;
    }
  }

  @media screen and (max-width: 600px) {
    margin-top: 56px;

    ::v-deep .el-carousel__container {
      height: 250px !important;
    }

    .banner-copy {
      left: 20px;
      width: calc(100% - 40px);

      h1 {
        margin-bottom: 10px;
        font-size: 24px;
      }

      p {
        margin-bottom: 16px;
        font-size: 14px;
      }
    }

    .banner-action {
      padding: 8px 18px;
      font-size: 14px;
    }
  }
}
</style>
